import { print } from 'graphql'
import { Customer } from 'shopify-types'

import { storefrontClient } from '..'
import { FetchCustomerDocument, type FetchCustomerQuery } from '../__generated/storefront'
import { UnauthorizedError } from '../errors'
import { GlobalRequestOptions } from '../types'
import { mapGQLCustomerToCustomer } from './graphql'

export const fetchCustomer =
  (options: GlobalRequestOptions) =>
  async (token: string): Promise<Customer> => {
    const response = await storefrontClient.request<FetchCustomerQuery>(
      print(FetchCustomerDocument),
      {
        variables: {
          customerAccessToken: token,
          language: options.language,
        },
      },
    )

    // No `data` = transient request failure (retryable).
    if (!response.data) {
      throw new Error('Failed to fetch customer (transient)')
    }

    // `customer: null` = token rejected (the query only nulls for a bad token).
    if (!response.data.customer) {
      throw new UnauthorizedError('Customer access token is invalid')
    }

    return mapGQLCustomerToCustomer(response.data.customer)
  }
